import React from "react";
import { Form, Button } from "react-bootstrap";

export default function ImportData({ Load }) {
  return (
    <table className="halfTable">
      <thead className="halfTableheadborder">
        <tr>
          <th className="col-1">
            <h4 className="ms-1 mt-2">Import Data</h4>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="col-8">
            <Form.Control type="file" onChange={(e) => Load(e)} />
          </td>
        </tr>
      </tbody>
      <tfoot className="foot halfFoot hideBorders">
        <tr>
          <td></td>
        </tr>
      </tfoot>
    </table>
  );
}
